import { Button, ButtonGroup, DialogBody, DialogFooter, Stack, Text } from "@chakra-ui/react";
import { UI } from "components";
import { toaster } from "config";
import { API } from "config";
import useOrder from "hooks/useOrder";
import { useState } from "react";

export default function Withdraw({ data = {}, ...props }){

    const order = useOrder(data?.id)
    const [ loading, setLoading ] = useState(false)

    const handleSubmit = async () => {
        if(!window.confirm('Tem certeza que deseja continuar?')) return
        setLoading(true)

        try{
            await API.put(`/orders/${order?.data?.id}/withdraw`)
            toaster.create({ title: 'O pedido foi marcado para retirada', type: 'success' })
            order.refetch()
            props.onClose()
        }catch(err){
            toaster.create({ title: 'Não foi possível alterar o status do pedido', description: err?.response?.data?.message, type: 'warning' })
        }

        setLoading(false)
    }

    return(
    <UI.Dialog loading={loading} size="sm" title={`O pedido #${order.data?.cod} está pronto para retirada?`} {...props}>
        <DialogBody>
            <Stack gap={3}>
                <Text fontSize="sm">Ao continuar, você estará alterando o status do pedido para <b>Aguardando Retirada</b> e seu cliente será avisado que o pedido está pronto para retirada em seu núcleo.</Text>
                <Text>Tem certeza que deseja prosseguir?</Text>
            </Stack>
        </DialogBody>
        <DialogFooter>
            <ButtonGroup>
                <Button loading={loading} variant="subtle" colorPalette="blue" onClick={handleSubmit}><UI.Icon name="done" /> Pronto para retirada</Button>
                <Button disabled={loading} variant="ghost" onClick={props.onClose}>Fechar</Button>
            </ButtonGroup>
        </DialogFooter>
    </UI.Dialog>
    )    
}